import moment from 'moment';

interface DayHours {
    open?: string;
    close?: string;
    isClosed: boolean;
}

interface BusinessHours {
    monday?: DayHours;
    tuesday?: DayHours;
    wednesday?: DayHours;
    thursday?: DayHours;
    friday?: DayHours;
    saturday?: DayHours;
    sunday?: DayHours;
}

export function addBusinessDays(
    date: Date | moment.Moment,
    businessDays: number,
    businessHours?: BusinessHours
): moment.Moment {
    let result = moment(date);

    if (!businessHours) {
        return result.add(businessDays, 'days');
    }

    let daysAdded = 0;

    while (daysAdded < businessDays) {
        result = result.add(1, 'day');

        if (isBusinessDay(result, businessHours)) {
            daysAdded++;
        }
    }

    return result;
}
function isBusinessDay(date: moment.Moment, businessHours?: BusinessHours): boolean {
    if (!businessHours) {
        return true;
    }

    const dayOfWeek = date.day(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

    // Map day of week to BusinessHours property
    const dayName = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][dayOfWeek] as keyof BusinessHours;
    const dayHours = businessHours[dayName];

    // If day is not configured or is marked as closed, it's not a business day
    if (!dayHours || dayHours.isClosed) {
        return false;
    }

    return true;
}
